export default {"src":"/_next/static/media/analytics.bb1528e2.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};